// extracted by mini-css-extract-plugin
export default {"NotFound_container":"NotFoundPage_NotFound_container__nAxc7","error_container":"NotFoundPage_error_container__tAuZ8"};